export type Subject = {
  slug: string;
  name: string;
  tagline: string;
  description: string;
  emoji: string;
  color: string;
  available: boolean;
  units?: { title: string; lessons: number; free?: boolean }[];
};

export const subjects: Subject[] = [
  {
    slug: "romanian",
    name: "Limba și literatura română",
    tagline: "De la Eminescu la Cărtărescu",
    description:
      "Un parcurs complet prin literatura română — curentele, autorii și operele care intră la BAC, de la pașoptiști la postmodernism.",
    emoji: "📖",
    color: "from-primary to-accent",
    available: true,
    units: [
      { title: "Literatura română — curente literare", lessons: 56, free: true },
      { title: "Romanul românesc", lessons: 30 },
      { title: "Dramaturgie", lessons: 12 },
      { title: "Limba română", lessons: 27 },
    ],
  },
  { slug: "math", name: "Matematică", tagline: "Logică și frumusețe", description: "În curând.", emoji: "✏️", color: "from-tertiary to-secondary", available: false },
  { slug: "history", name: "Istorie", tagline: "Povestea noastră", description: "În curând.", emoji: "🏛️", color: "from-accent to-primary", available: false },
  { slug: "physics", name: "Fizică", tagline: "Legile universului", description: "În curând.", emoji: "⚛️", color: "from-primary to-secondary", available: false },
  { slug: "chemistry", name: "Chimie", tagline: "Reacții și molecule", description: "În curând.", emoji: "🧪", color: "from-accent to-tertiary", available: false },
  { slug: "biology", name: "Biologie", tagline: "Viața în detaliu", description: "În curând.", emoji: "🌱", color: "from-secondary to-tertiary", available: false },
  { slug: "geography", name: "Geografie", tagline: "Lumea pe hartă", description: "În curând.", emoji: "🗺️", color: "from-tertiary to-primary", available: false },
  { slug: "logic", name: "Logică și argumentare", tagline: "Gândire critică", description: "În curând.", emoji: "🧠", color: "from-primary to-accent", available: false },
  { slug: "psychology", name: "Psihologie", tagline: "Mintea umană", description: "În curând.", emoji: "🧩", color: "from-secondary to-primary", available: false },
  { slug: "sociology", name: "Sociologie", tagline: "Oamenii și societatea", description: "În curând.", emoji: "👥", color: "from-accent to-secondary", available: false },
  { slug: "economics", name: "Economie", tagline: "Piețe și decizii", description: "În curând.", emoji: "📈", color: "from-tertiary to-accent", available: false },
  { slug: "philosophy", name: "Filosofie", tagline: "Întrebările esențiale", description: "În curând.", emoji: "💭", color: "from-primary to-tertiary", available: false },
  
];

export const team = [
  { name: "Andrei Popescu", role: "Fondator & profesor de română", bio: "15 ani la catedră, pasionat de literatura interbelică.", initials: "AP" },
  { name: "Maria Ionescu", role: "Director pedagogic", bio: "Doctor în științele educației, designer de curriculum.", initials: "MI" },
  { name: "Vlad Dumitrescu", role: "Lead developer", bio: "Construiește instrumente care fac învățarea să fie un joc.", initials: "VD" },
  { name: "Ioana Marin", role: "Designer & ilustrator", bio: "Crede că un manual frumos se citește mai cu drag.", initials: "IM" },
];

export const faqs = [
  { q: "Cum funcționează perioada de probă?", a: "Toți utilizatorii noi primesc 7 zile de acces complet, gratuit. Nu se plătește nimic în această perioadă și poți anula oricând." },
  { q: "Ce conține planul gratuit?", a: "Primele 1-2 unități din fiecare materie sunt complet gratuite, ca să te asiguri că stilul nostru ți se potrivește." },
  { q: "Pot anula oricând?", a: "Da. Anularea se face cu un singur click din contul tău, iar accesul rămâne activ până la finalul perioadei plătite." },
  { q: "Materialele sunt descărcabile?", a: "Da — toate lecțiile au PDF-uri descărcabile pentru recapitulare offline." },
  { q: "Pe ce dispozitive funcționează?", a: "Pe orice browser modern: telefon, tabletă, laptop. Nu trebuie să instalezi nimic." },
  { q: "Cine scrie materialele?", a: "Profesori cu experiență, fiecare specializat pe materia lui, în colaborare cu echipa noastră pedagogică." },
  { q: "Există suport pentru elevi?", a: "Lucrăm chiar acum la o comunitate „elevi pentru elevi” unde vei putea pune întrebări și primi răspunsuri de la colegi și mentori. Se deschide în curând — între timp, abonații Premium au acces prioritar la suport pe email." },
];
